<script setup>
import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
    modelValue: [String, Array, Object],
    label: String,
    options: { type: Array, default: () => [] },
    required: Boolean,
    multiple: Boolean,
    rules: {
        type: Array,
        default: () => []
    },
})

const emit = defineEmits(['update:modelValue'])

const internalValue = ref(props.modelValue ?? (props.multiple ? [] : ''));

// sempre que o valor externo mudar → sincroniza
// watch(
//     () => props.modelValue,
//     (newVal) => {
//         if (JSON.stringify(newVal) !== JSON.stringify(internalValue.value)) {
//             internalValue.value = newVal
//         }
//     }
// )

watch(
    internalValue,
    (val) => {
        if (props.multiple) {
            // garante que sempre seja array
            const arr = Array.isArray(val) ? val : val ? [val] : [];

            let cleaned = arr
                .map(item => {
                    if (!item) return ''
                    if (typeof item === 'object') return item.value ?? item.title ?? ''
                    return item
                })
                .map(v => String(v).trim())
                .filter(v => v !== '')

            cleaned = cleaned.join(', ')
            emit('update:modelValue', cleaned)
        } else {
            // valor único → transforma em string simples
            let cleaned = ''
            if (val && typeof val === 'object') {
                cleaned = val.value ?? val.title ?? ''
            } else if (typeof val === 'string') {
                cleaned = val.trim()
            }
            emit('update:modelValue', cleaned)
        }
    },
    { deep: true }
)


const mappedItems = computed(() =>
    props.options.map(opt => ({
        title: t(opt.label),
        value: opt.value
    }))
)

const requiredRule = (v) =>
    !!v || t('common.messages.validations.required')

const combinedRules = computed(() => {
    const rules = [...props.rules]
    if (props.required) rules.unshift(requiredRule)
    return rules
})
</script>

<template>
    <v-combobox
        class="field-default"
        :model-value="modelValue"
        :label="t(label)"
        :items="mappedItems"
        item-title="title"
        item-value="value"
        :multiple="multiple"
        :required="required"
        :rules="combinedRules"
        @update:model-value="emit('update:modelValue', $event)"
        clearable
        chips
        closable-chips
    />
</template>
